import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "w-full flex items-center gap-2 py-1.5 px-2 text-xs pointer-events-none mt-1 bg-error-10 text-error-100 rounded"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.data?.hasError && $props.data?.msg ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("i", {
    class: "icon-exclamation-rounded text-base"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($props.data.msg), 1)])) : _createCommentVNode("", true);
}